"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactstrap = require("reactstrap");

var _auth = require("@dom/app/src/actions/auth");

var _FormState = _interopRequireDefault(require("./FormState"));

var _GoogleLogin = _interopRequireDefault(require("./GoogleLogin"));

var _FacebookLogin = _interopRequireDefault(require("./FacebookLogin"));

require("./assets/login.scss"); // import { withRouter } from 'react-router';
// import config from '../../config';
// import analytics from '../../analytics';


var hgLogo = 'https://s3.amazonaws.com/honeyguide/assets/logo.png';
var styles = {
  modal: {
    maxWidth: '360px'
  }
};
var form = {
  headerText: {
    signup: 'Get the Best out of your Trek with one Insight a Day',
    login: 'Get the Best out of your Trek with one Insight a Day'
  },
  buttonText: {
    signup: 'Sign up with Email and Password',
    login: 'Login  with Email and Password'
  },
  belowButtonText: {
    signup: 'Already a member?',
    login: 'Not a member'
  },
  belowButtonLinks: {
    signup: 'Log In',
    login: 'Create an account'
  },
  facebook: {
    signup: 'Sign up with Facebook',
    login: 'Login with Facebook'
  },
  google: {
    signup: 'Sign up with Google',
    login: 'Login with Google'
  }
};

var LoginModal =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(LoginModal, _Component);

  function LoginModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, LoginModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(LoginModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      showForm: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onShowForm", function () {
      return _this.setState({
        showForm: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideForm", function () {
      if (_this.state.showForm) _this.setState({
        showForm: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeModal", function () {
      var closeAuthModal = _this.props.closeAuthModal;
      closeAuthModal(); // not checking whether the nested modal is opened or not
      // since any nested modal opening will
      // update this component causing unnecessary render.
      // setTimeout(() => closeNestedModal(), 500);

      _this.clearServerError();

      _this.hideForm(); // analytics.closeSignUpForm();

    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleSignup", function () {
      _this.clearServerError();

      clearTimeout();
      setTimeout(_this.toggleForm, 300);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleForm", function () {
      var _this$props = _this.props,
          openSignUpModal = _this$props.openSignUpModal,
          openLoginModal = _this$props.openLoginModal,
          isSignUp = _this$props.isSignUp;
      return isSignUp ? openLoginModal() : openSignUpModal();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearServerError", function () {
      var _this$props2 = _this.props,
          serverError = _this$props2.serverError,
          clearError = _this$props2.clearError;
      if (serverError) clearError();
    });
    return _this;
  }

  (0, _createClass2["default"])(LoginModal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout();
    }
  }, {
    key: "render",
    value: function render() {
      var showForm = this.state.showForm;
      var _this$props3 = this.props,
          login = _this$props3.login,
          loading = _this$props3.loading,
          requestLogin = _this$props3.requestLogin,
          serverError = _this$props3.serverError,
          registerAccount = _this$props3.registerAccount,
          isSignUp = _this$props3.isSignUp;
      var headerText = form.headerText,
          buttonText = form.buttonText,
          belowButtonLinks = form.belowButtonLinks,
          belowButtonText = form.belowButtonText,
          facebook = form.facebook,
          google = form.google;
      var authType = isSignUp ? 'signup' : 'login';

      var Facebook = _react["default"].createElement(_FacebookLogin["default"], {
        key: "facebook",
        submit: isSignUp ? registerAccount : requestLogin,
        loading: loading,
        buttonText: facebook[authType]
      });

      var Google = _react["default"].createElement(_GoogleLogin["default"], {
        key: "google",
        submit: isSignUp ? registerAccount : requestLogin,
        loading: loading,
        buttonText: google[authType]
      });

      var Signup = _react["default"].createElement(_FormState["default"], {
        isSignUpForm: isSignUp,
        submit: registerAccount,
        loading: loading,
        loadingTextIndicator: "JOINING",
        buttonText: "JOIN HONEYGUIDE",
        clearServerError: this.clearServerError
      });

      var Login = _react["default"].createElement(_FormState["default"], {
        isSignUpForm: isSignUp,
        submit: requestLogin,
        loading: loading,
        loadingTextIndicator: "LOGGING IN",
        buttonText: "LOGIN",
        clearServerError: this.clearServerError
      });

      var authForm = _react["default"].createElement(_reactstrap.Form, {
        className: "auth-form"
      }, _react["default"].createElement("div", {
        className: "error"
      }, serverError), isSignUp ? Signup : Login);

      var formButton = _react["default"].createElement(_reactstrap.Button, {
        key: "formButton",
        onClick: this.onShowForm,
        color: "primary",
        className: "btn-social"
      }, buttonText[authType]);

      return _react["default"].createElement(_reactstrap.Modal, {
        isOpen: login,
        toggle: this.closeModal,
        className: "login-modal",
        style: styles.modal
      }, _react["default"].createElement(_reactstrap.ModalBody, null, _react["default"].createElement("button", {
        type: "button",
        className: "closeModal",
        "aria-label": "Close",
        onClick: this.closeModal
      }, _react["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), _react["default"].createElement("div", {
        className: "login-holder"
      }, _react["default"].createElement("div", {
        className: "form"
      }, _react["default"].createElement("div", {
        className: "greeting"
      }, _react["default"].createElement("div", {
        className: "logo"
      }, _react["default"].createElement("img", {
        src: hgLogo,
        alt: "HoneyGuide Logo",
        className: "img-full"
      })), _react["default"].createElement("h1", null, headerText[authType])), _react["default"].createElement("div", {
        className: "login-action"
      }, showForm ? _react["default"].createElement(_react.Fragment, null, [authForm, Facebook, Google]) : _react["default"].createElement(_react.Fragment, null, [Facebook, Google, formButton]), _react["default"].createElement("p", {
        className: "form-toggle"
      }, belowButtonText[authType], ' ', _react["default"].createElement("a", {
        onClick: this.toggleSignup
      }, belowButtonLinks[authType]))), _react["default"].createElement("div", {
        className: "message"
      }, _react["default"].createElement("p", {
        className: "mt-3 mb-1"
      }, "Trusted by Over 18,000 trekkers &"), _react["default"].createElement("ul", {
        className: "trust-img"
      }, _react["default"].createElement("li", null, _react["default"].createElement("img", {
        src: "https://s3.amazonaws.com/honeyguide/assets/lp-white.png",
        alt: ""
      })), _react["default"].createElement("li", null, _react["default"].createElement("img", {
        src: "https://s3.amazonaws.com/honeyguide/assets/wb-white.png",
        alt: ""
      })), _react["default"].createElement("li", null, _react["default"].createElement("img", {
        src: "https://s3.amazonaws.com/honeyguide/assets/slush-white.png",
        alt: ""
      })), _react["default"].createElement("li", null, _react["default"].createElement("img", {
        src: "https://s3.amazonaws.com/honeyguide/assets/bw-white.png",
        alt: ""
      }))))))));
    }
  }]);
  return LoginModal;
}(_react.Component);

var _default = (0, _reactRedux.connect)(function (_ref) {
  var auth = _ref.auth;
  return {
    login: auth.isModalOpen,
    isSignUp: auth.isSignUpOpen,
    serverError: auth.error,
    loading: auth.isFetching
  };
}, {
  requestLogin: _auth.requestLogin,
  registerAccount: _auth.registerAccount,
  clearError: _auth.clearError,
  closeAuthModal: _auth.closeAuthModal,
  openSignUpModal: _auth.openSignUpModal,
  openLoginModal: _auth.openLoginModal
})(LoginModal);

exports["default"] = _default;